var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "flexbox",
    {
      staticClass: "message-cell",
      class: { "is-unread": _vm.data.is_read == 0 },
      attrs: { align: "stretch" },
    },
    [
      _c("div", { staticClass: "message-cell__hd" }, [
        _c("i", { class: _vm.typeObj.icon }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-cell__bd" }, [
        _c("span", [_vm._v(_vm._s(_vm.leftContent))]),
        _vm._v(" "),
        _c(
          "span",
          {
            class: [{ "is-invalid": _vm.isInvalid }, "click-content"],
            on: { click: _vm.enterDetail },
          },
          [_vm._v(_vm._s(_vm.centerCotent))]
        ),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.rightContent))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-cell__ft" }, [
        _c("div", [
          _vm._v(_vm._s(_vm._f("formatTime")(_vm.data.create_time)) + " "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "handle" }, [
          _c(
            "span",
            { staticClass: "check", on: { click: _vm.messageReadClick } },
            [_vm._v("标记已读")]
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "delete", on: { click: _vm.messageDeleteClick } },
            [_vm._v("删除")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }